import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import { Container } from "../components";
import { toMultiPassAccess } from "../fm/data/orders";
import { MultiPassAccess, Partner, useMultiAccessesQuery } from "./api";
import { Content } from "./content";
import { Divider } from "./divider";
import { MultiPassCard } from "./multipass_card";
import { PartnerConfig } from "./partner_config";
import { PartnerPortalFooter } from "./partner_portal_footer";
import { Spacer } from "./spacer";
import { TextLink } from "./text_link";

interface TemplatePartnerPortalIndexProps {
  partnerConfig: PartnerConfig;
  partner: Partner;
}

export function TemplatePartnerPortalIndex(
  props: TemplatePartnerPortalIndexProps
) {
  const { partnerConfig, partner } = props;
  const { slug, partnerName, favicon, homepageURL, portalHelpEmail } =
    partnerConfig;
  const { logout } = useAuth0();
  const { data } = useMultiAccessesQuery(partner.id);
  const multiPassAccesses: MultiPassAccess[] = data.map(toMultiPassAccess);
  const filteredMultiPassAccesses = multiPassAccesses.filter((mpa) => true);

  return (
    <div>
      <PortalHead title={partnerName} favicon={favicon} />
      <PortalHeader homepageURL={homepageURL} logo={partner.logoUrl} />
      <Divider />
      <Spacer size={32} />
      <Content>
        <div className="partner-portal-expand-content">
          <Container paddingHorizontal={16}>
            <MultiPassCardList
              slug={slug}
              multiPassAccesses={filteredMultiPassAccesses}
            />
          </Container>
        </div>
        <Container paddingHorizontal={16} paddingBottom={12}>
          <TextLink
            onPress={() =>
              logout({ returnTo: `${window.location.origin}/portal/${slug}` })
            }
            weight="500"
          >
            Log out
          </TextLink>
        </Container>
      </Content>
      <PartnerPortalFooter portalHelpEmail={portalHelpEmail} />
    </div>
  );
}

interface PortalHeadProps {
  title: string;
  favicon: string;
}

export function PortalHead(props: PortalHeadProps) {
  const { title, favicon } = props;

  return (
    <Helmet>
      <title>{title} Portal</title>
      <link href={favicon} rel="shortcut icon" type="image/x-icon" />
    </Helmet>
  );
}

interface PortalHeaderProps {
  logo: string;
  homepageURL: string;
}

export function PortalHeader(props: PortalHeaderProps) {
  const { logo, homepageURL } = props;

  return (
    <Content>
      <div className="header">
        <a className="offering-header-logo-link" href={homepageURL}>
          <img className="offering-header-logo" alt="logo" src={logo} />
        </a>
      </div>
    </Content>
  );
}

interface MultiPassCardListProps {
  slug: string;
  multiPassAccesses: MultiPassAccess[];
}

function MultiPassCardList(props: MultiPassCardListProps) {
  const { multiPassAccesses, slug } = props;

  return (
    <Container>
      {multiPassAccesses.map((mpa) => (
        <Link
          key={mpa.id}
          style={{ textDecoration: "none", paddingBottom: 16 }}
          to={`/portal/${slug}/${mpa.id}`}
        >
          <MultiPassCard multiPassAccess={mpa} />
        </Link>
      ))}
    </Container>
  );
}
